import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Marque avec logo */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/soleil-azur-logo.png" 
                alt="Logo Soleil d'Azur" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-xl font-inter font-semibold">Soleil d'Azur</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed font-inter">
              Créons des solutions de communication exceptionnelles qui connectent les marques avec leur audience grâce à un design innovant et une réflexion stratégique.
            </p>
          </div>

          {/* Liens rapides */}
          <div>
            <h3 className="text-lg font-inter font-semibold mb-4 text-white">Liens Rapides</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-amber-400 transition-colors text-sm font-inter">Accueil</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-amber-400 transition-colors text-sm font-inter">À Propos</Link></li>
              <li><Link to="/plans" className="text-gray-400 hover:text-amber-400 transition-colors text-sm font-inter">Formules</Link></li>
              <li><Link to="/resources" className="text-gray-400 hover:text-amber-400 transition-colors text-sm font-inter">Ressources</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-amber-400 transition-colors text-sm font-inter">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-inter font-semibold mb-4 text-white">Services</h3>
            <ul className="space-y-2">
              <li><span className="text-gray-400 text-sm font-inter">Stratégie de Marque</span></li>
              <li><span className="text-gray-400 text-sm font-inter">Marketing Digital</span></li>
              <li><span className="text-gray-400 text-sm font-inter">Création de Contenu</span></li>
              <li><span className="text-gray-400 text-sm font-inter">Réseaux Sociaux</span></li>
              <li><span className="text-gray-400 text-sm font-inter">Développement Web</span></li>
            </ul>
          </div>

          {/* Informations de contact */}
          <div>
            <h3 className="text-lg font-inter font-semibold mb-4 text-white">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-amber-400" />
                <span className="text-gray-400 text-sm font-inter">contact@soleil-azur.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-amber-400" />
                <span className="text-gray-400 text-sm font-inter">+33 6 43 84 00 01</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin size={16} className="text-amber-400" />
                <span className="text-gray-400 text-sm font-inter">France, 11100 Narbonne</span>
              </div>
              <div className="mt-4 p-3 bg-amber-100/10 rounded-full">
                <span className="text-amber-200 text-sm font-medium font-inter">Réponse sous 24 h</span>
              </div>
            </div>
          </div>
        </div>

        {/* Réseaux sociaux & Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0 font-inter">
            © 2024 Soleil d'Azur. Tous droits réservés.
          </p>
          <div className="flex space-x-4">
            <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">
              <Facebook size={20} />
            </a>
            <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">
              <Twitter size={20} />
            </a>
            <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">
              <Instagram size={20} />
            </a>
            <a href="#" className="text-gray-400 hover:text-amber-400 transition-colors">
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
